import type { RoleDto } from "common/models/api/models/RoleDto";
import { useAuthStore } from "features/auth/store/authStore";

export default (role: RoleDto) => {
    useAuthStore.getState().setSelectedRole(role);
};
